module.exports = __webpack_public_path__ + "static/img/new15-Pm3Xz8Wb.dc8aacb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new15-Pm3Xz8Wb.png
// module id = G1PH
// module chunks = 16